import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'

// Defines what data should be loaded for this component, the data in here is
// fetched in parallel with navigating to the route and is then passed to the
// component as a prop.
export default async function loader() {
  return defer({
    data: mercuryApi
      .get('/pay-rules/packages?includeActivatedPackagesOnly=false')
      .then((allPackages) => {
        // remove any packages that are already activated
        return allPackages.filter((p) => p.activation === null)
      }),
  })
}
